// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uAkwW","left":"styles_left__1eU_j"};